// eslint-disable-next-line no-unused-expressions
(function () {
  var HERO_STICKY_MAX = 1023;
  var SLOT_HIDDEN_CLASS = 'product-hero__form-slot--hidden';
  var DOCK_ACTIVE_CLASS = 'product-hero__form-dock--active';
  var PIN_OFFSET_PX = 8;

  function initHeroSlider(slider) {
    if (!slider) return;
    if (typeof Swiper === 'undefined') return;

    var scope = slider.parentElement || document;
    var prevBtn = scope.querySelector('[data-hero-prev]');
    var nextBtn = scope.querySelector('[data-hero-next]');
    var paginationEl = scope.querySelector('[data-hero-pagination]');

    new Swiper(slider, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 400,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : false,
    });
  }

  function initHeroExtrasSlider(slider) {
    if (!slider) return;
    if (typeof Swiper === 'undefined') return;

    var scope = slider.closest('.product-hero-extras__inner') || slider.parentElement || document;
    var prevBtn = scope.querySelector('[data-hero-extras-prev]');
    var nextBtn = scope.querySelector('[data-hero-extras-next]');
    var paginationEl = scope.querySelector('[data-hero-extras-pagination]');

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      speed: 400,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : false,
      breakpoints: {
        744: {
          slidesPerView: 1,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    });
  }

  function initProductHeroStickyForm() {
    if (window.__heroStickyFormBound) return;

    var form = null;
    var slot = null;
    var dock = null;
    var dockBtn = null;
    var sectionId = null;
    var originalParent = null;
    var originalNext = null;
    var dockOriginalParent = null;
    var dockOriginalNext = null;
    var pinned = false;
    var observer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function refreshElements() {
      form = document.querySelector('product-form.product-hero__form');
      slot = document.querySelector('[data-hero-form-slot]');
      dock = document.querySelector('[data-hero-form-dock]');
      if (!form || !slot || !dock) return false;

      sectionId = form.dataset.sectionId || dock.dataset.sectionId;
      dockBtn = ensureDockButton();

      if (!originalParent || !form.parentElement.isConnected) {
        originalParent = form.parentElement;
        originalNext = form.nextElementSibling;
      }

      if (!dockOriginalParent || !dockOriginalParent.isConnected) {
        dockOriginalParent = dock.parentElement;
        dockOriginalNext = dock.nextElementSibling;
      }

      return true;
    }

    function isStickyViewport() {
      return window.innerWidth <= HERO_STICKY_MAX;
    }

    function getSubmitButton() {
      if (!form) return null;
      if (!sectionId) return form.querySelector('[type="submit"][name="add"]');
      return document.getElementById('ProductSubmitButton-' + sectionId);
    }

    function ensureDockButton() {
      if (!dock) return null;

      var btn = dock.querySelector('[data-hero-dock-submit]');
      if (btn) return btn;

      var submit = getSubmitButton();
      if (!submit) return null;

      var clone = submit.cloneNode(true);
      clone.removeAttribute('id');
      clone.type = 'button';
      clone.name = '';
      clone.classList.add('product-hero__submit--dock');
      clone.setAttribute('data-hero-dock-submit', '');
      dock.appendChild(clone);
      return clone;
    }

    function syncDockState() {
      dockBtn = ensureDockButton();
      if (!dockBtn) return;

      var submit = getSubmitButton();
      var soldOut = form && form.classList.contains('product-hero__form--sold-out');

      if (!submit || soldOut) {
        dockBtn.disabled = true;
        dockBtn.setAttribute('aria-disabled', 'true');
        return;
      }

      dockBtn.disabled = submit.disabled;
      if (submit.disabled) {
        dockBtn.setAttribute('aria-disabled', 'true');
      } else {
        dockBtn.removeAttribute('aria-disabled');
      }
    }

    function mountDockToBody() {
      if (!dock || dock.parentElement === document.body) return;
      document.body.appendChild(dock);
    }

    function restoreDockPlacement() {
      if (!dock || dock.parentElement === dockOriginalParent) return;
      if (dockOriginalNext && dockOriginalNext.parentElement === dockOriginalParent) {
        dockOriginalParent.insertBefore(dock, dockOriginalNext);
      } else if (dockOriginalParent) {
        dockOriginalParent.appendChild(dock);
      }
    }

    function restoreDesktop() {
      if (!dock) return;
      restoreDockPlacement();
      dock.hidden = true;
      dock.setAttribute('hidden', '');
      dock.setAttribute('aria-hidden', 'true');
      dock.classList.remove(DOCK_ACTIVE_CLASS);

      if (!form || form.parentElement === originalParent) return;
      if (originalNext && originalNext.parentElement === originalParent) {
        originalParent.insertBefore(form, originalNext);
      } else if (originalParent) {
        originalParent.appendChild(form);
      }
    }

    function placeInline() {
      if (!refreshElements()) return;

      if (!isStickyViewport()) {
        restoreDesktop();
        return;
      }

      mountDockToBody();
      if (form.parentElement !== slot) {
        slot.appendChild(form);
      }
    }

    function getAnchorRect() {
      var submit = getSubmitButton();
      if (submit) return submit.getBoundingClientRect();
      if (slot) return slot.getBoundingClientRect();
      return { top: 0, bottom: 0, left: 0, right: 0 };
    }

    function showDock() {
      if (!dock) return;
      dockBtn = ensureDockButton();
      if (!dockBtn) return;

      dock.hidden = false;
      dock.removeAttribute('hidden');
      dock.setAttribute('aria-hidden', 'false');
      syncDockState();
      dock.classList.remove(DOCK_ACTIVE_CLASS);

      if (reduceMotion) {
        dock.classList.add(DOCK_ACTIVE_CLASS);
      } else {
        requestAnimationFrame(function () {
          dock.classList.add(DOCK_ACTIVE_CLASS);
        });
      }
    }

    function hideDock() {
      if (!dock) return;
      dock.classList.remove(DOCK_ACTIVE_CLASS);
      dock.hidden = true;
      dock.setAttribute('hidden', '');
      dock.setAttribute('aria-hidden', 'true');
    }

    function updateStickyState() {
      if (!refreshElements() || !isStickyViewport()) return;

      var r = getAnchorRect();
      var vh = window.innerHeight;

      if (r.bottom <= -PIN_OFFSET_PX) {
        setPinned(true);
        return;
      }

      if (r.top < vh && r.bottom > PIN_OFFSET_PX) {
        setPinned(false);
      }
    }

    function setPinned(on) {
      if (on === pinned) return;

      if (on) {
        if (!refreshElements() || !ensureDockButton()) return;
      }

      pinned = on;

      if (on) {
        slot.classList.add(SLOT_HIDDEN_CLASS);
        placeInline();
        showDock();
      } else {
        slot.classList.remove(SLOT_HIDDEN_CLASS);
        hideDock();
        placeInline();
      }
    }

    function onIntersect() {
      updateStickyState();
    }

    function startObserver() {
      if (!slot) return;
      if (observer) {
        observer.disconnect();
      } else {
        observer = new IntersectionObserver(onIntersect, { threshold: [0, 0.01, 1] });
      }
      observer.observe(slot);
    }

    function stopObserver() {
      if (!observer) return;
      observer.disconnect();
      observer = null;
    }

    function syncLayout() {
      if (!refreshElements()) return;

      if (isStickyViewport()) {
        if (pinned) {
          slot.classList.remove(SLOT_HIDDEN_CLASS);
          pinned = false;
          hideDock();
        }
        placeInline();
        startObserver();
        syncDockState();
      } else {
        stopObserver();
        slot.classList.remove(SLOT_HIDDEN_CLASS);
        pinned = false;
        restoreDesktop();
      }
    }

    function onVariantChange(event) {
      if (!event || !event.data) return;
      if (sectionId && String(event.data.sectionId) !== String(sectionId)) return;

      refreshElements();
      placeInline();
      syncDockState();
      updateStickyState();
    }

    function onDockClick(event) {
      var btn = event.target.closest('[data-hero-dock-submit]');
      if (!btn || !dock || !dock.contains(btn)) return;

      refreshElements();
      var submit = getSubmitButton();
      if (!submit || submit.disabled) return;
      submit.click();
    }

    if (!refreshElements()) return;

    window.__heroStickyFormBound = true;

    document.addEventListener('click', onDockClick);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }

    var submitEl = getSubmitButton();
    if (submitEl && typeof MutationObserver !== 'undefined') {
      var submitObserver = new MutationObserver(function () {
        refreshElements();
        syncDockState();
      });
      submitObserver.observe(submitEl, { attributes: true, attributeFilter: ['disabled', 'class'] });
    }

    window.addEventListener(
      'scroll',
      function () {
        updateStickyState();
      },
      { passive: true }
    );

    window.addEventListener('resize', syncLayout, { passive: true });

    syncLayout();
    updateStickyState();
  }

  function initAll() {
    document.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
    document.querySelectorAll('[data-hero-extras-slider]').forEach(initHeroExtrasSlider);
    initProductHeroStickyForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
